export const columnHeader = [
  {
    key: "id",
    name: "#",
    type: "text",
    system: true,
    filter: true,
    canAdd: false,
    canEdit: false,
  },
  {
    key: "type",
    name: "Product",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: false,
  },
  {
    key: "display_name",
    name: "Name",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: true,
  },
  {
    key: "proxies",
    name: "Proxies",
    type: "text",
    system: true,
    filter: true,
    canAdd: false,
    canEdit: false,
  },
  {
    key: "cost",
    name: "Product Cost",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: true,
  },
  {
    key: "valid",
    name: "Renewal Date",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: true,
  },
  {
    key: "contract",
    name: "Contract",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: true,
  },
  {
    key: "usage",
    name: "Use Case",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: true,
  },
  {
    key: "website",
    name: "Website",
    type: "text",
    system: false,
    filter: true,
    canAdd: true,
    canEdit: true,
  },
  {
    key: "tags",
    name: "Tags",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  {
    key: "bandwidth",
    name: "Bandwidth",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  {
    key: "domains",
    name: "Domains",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  {
    key: "description",
    name: "Description",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  {
    key: "residential_username",
    name: "Username",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  {
    key: "residential_password",
    name: "Password",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  //   {
  //     key: 'concurrent_connection', name: 'Concurrent Connection', type: 'text', system: false, filter: false
  //   },
  {
    key: "locations",
    name: "Locations",
    type: "text",
    system: true,
    filter: false,
    canAdd: false,
    canEdit: false,
  },
  {
    key: "notes",
    name: "Notes",
    type: "text",
    system: false,
    filter: false,
    canAdd: false,
    canEdit: true,
  },
  {
    key: "created",
    name: "Created",
    type: "text",
    system: true,
    filter: true,
    canAdd: false,
    canEdit: false,
  },
];

export const types = [
  { value: "Custom", label: "Custom" },
  { value: "Premium", label: "Premium" },
  { value: "Private", label: "Private" },
];

export const contracts = [
  { value: "Trial", label: "Trial" },
  { value: "30 days", label: "30 days" },
  { value: "90 Days", label: "90 Days" },
  { value: "180 days", label: "180 days" },
  { value: "360 days", label: "360 days" },
];

export const concurrentConnection = [
  { value: "5", label: "Limited to 5 concurrent connections" },
  { value: "yes", label: "Limited to 50 concurrent connections" },
  { value: "no", label: "Limited to 500 concurrent connections" },
];

export const validDays = [
  {
    value: 1,
    label: "1 Day",
  },
  {
    value: 2,
    label: "2 Days",
  },
  {
    value: 3,
    label: "3 Days",
  },
  {
    value: 7,
    label: "7 Days",
  },
  {
    value: 15,
    label: "15 Days",
  },
  {
    value: 30,
    label: "30 Days",
  },
  {
    value: 60,
    label: "60 Days",
  },
  {
    value: 90,
    label: "90 Days",
  },
  {
    value: 180,
    label: "180 Days",
  },
  {
    value: 365,
    label: "1 Year",
  },
];

export const concurrent_connections = [
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

export const locations = [
  { id: "1", name: "Location 1" },
  { id: "2", name: "Location 2" },
  { id: "3", name: "Location 3" },
  { id: "4", name: "Location 4" },
  { id: "5", name: "Location 5" },
];

export const products = [
  {
    id: 1,
    product: "Product #1",
    type: "Custom",
    proxies: 10,
    locations: 2,
    users: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 2,
    product: "Product #1",
    type: "Custom",
    proxies: 10,
    locations: 2,
    users: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 3,
    product: "Product #1",
    type: "Custom",
    proxies: 10,
    locations: 2,
    users: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 4,
    product: "Product #1",
    type: "Custom",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 5,
    product: "Product #1",
    type: "Custom",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 6,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 7,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 8,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 9,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 10,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 11,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    users: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 12,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    users: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 13,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    users: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 14,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 15,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 16,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 17,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 18,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 19,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
  {
    id: 20,
    product: "Product #1",
    proxies: 10,
    locations: 2,
    amount: "199",
    bandwidth: "100 GB",
    concurrent_connection: 1,
    notes: "notes",
  },
];
